module.exports = __webpack_public_path__ + "img/manualHelp.75af1a3f.svg";